import { useEffect, useState } from "react";
import { Map } from "../Components/Map";
import Error from "../Layouts/Error";
import InnerHeader from "../Layouts/InnerHeader";
import Loading from "../Layouts/Loading";
import { ContactRequest, useEditContactInfoMutation, useGetContactInfoQuery } from "../Redux/Apis/contactInfoApi";
import { useGetCitiesQuery } from "../Redux/Apis/utilApi";
import { toast } from 'react-toastify';

export default function Contact() {
    const [edit,{isLoading : isEditLoading}] = useEditContactInfoMutation()
    const [errorMsg, setErrorMsg] = useState<any>(false)

    const [formState, setFormState] = useState<ContactRequest>({
        phone: "",
        mobile: "",
        email: "",
        address: "",
        location: {},
        socials: [],
        city_id: null,
    })
    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const handleSocialChange = ({ target: { name, value:newVal },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => ({
            ...prev,
            socials: prev.socials?.map(
                (obj,index:number) => (index === +name ? {...obj,"value": newVal} : obj)
            )
        }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            await edit(formState).unwrap()
            toast.success('تغییرات ذخیره شد!');
            setErrorMsg(false) 
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }
    
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetContactInfoQuery({})
    const {
        data: cities,
        isLoading: isCityLoading,
    } = useGetCitiesQuery({})
    useEffect(() => {
        setFormState(data);
    }, [data])
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess){
        return(
        <div className="container-lg">
            <InnerHeader name="اطلاعات تماس"/>
            {errorMsg && <div className="alert alert-danger" role="alert">
                {errorMsg}
            </div>}
            <form className="row row-cols-1 row-cols-md-3 g-4" onSubmit={onSubmit}>
                <div className="col">
                    <div className="card h-80">
                        <div className="card-header">اطلاعات تماس</div>
                        <div className="card-body">
                            
                                <div className="mb-3">
                                    <label htmlFor="phoneInput" className="form-label">تلفن ثابت</label>
                                    <input type="text" dir="ltr" name="phone" defaultValue={data.phone} onChange={handleChange} className="form-control" id="phoneInput" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="mobileInput" className="form-label">شماره موبایل</label>
                                    <input type="text" dir="ltr" name="mobile" defaultValue={data.mobile} onChange={handleChange}  className="form-control" id="mobileInput" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="emailInput" className="form-label">ایمیل</label>
                                    <input type="email" name="email" defaultValue={data.email} onChange={handleChange}  className="form-control" id="emailInput" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="inputGroupSelect01">شهر:</label>
                                    <select name='city_id' defaultValue={data.city_id} onChange={(e) => setFormState((prev) => ({ ...prev, 'city_id': +e.target.value }))} className="form-select" id="inputGroupSelect01">
                                        {
                                            isCityLoading ? 
                                                <option>انتخاب...</option>
                                            : 
                                                cities && Object.values(cities).map((value:any,index:number) => 
                                                    <option value={value.id} key={index}>{value.name}</option>)
                                        }
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="addressTextarea" className="form-label">آدرس</label>
                                    <textarea className="form-control" name="address" defaultValue={data.address} onChange={handleChange}  id="addressTextarea" rows={3}></textarea>
                                </div>
                            
                        </div>
                        <div className="card-footer">
                            <button type="submit" disabled={isEditLoading} className="btn btn-outline-success float-end">ذخیره تغییرات</button>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card h-80">
                        <div className="card-header">شبکه های مجازی</div>
                        <div className="card-body">
                            {data.socials && data.socials.map((value:any,index:number) => 
                                <div className="mb-3" key={index}>
                                    <label htmlFor={`soicalInput${index}`} className="form-label">{value.key}</label>
                                    <input type="text" dir="ltr" className="form-control" name={`${index}`} onChange={handleSocialChange} defaultValue={value.value} id={`soicalInput${index}`}></input>
                                </div>
                            )}
                        </div>
                        <div className="card-footer">
                            <button type="submit" disabled={isEditLoading} className="btn btn-outline-success float-end">ذخیره تغییرات</button>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <div className="card-header">موقعیت جغرافیایی</div>
                        <div className="card-body">
                            <Map data={data.location} handleChange={setFormState}/>
                        </div>
                        <div className="card-footer">
                            <button type="submit" disabled={isEditLoading} className="btn btn-outline-success float-end">ذخیره تغییرات</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )}

    else return <></>
}